import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getSvgComponent } from "../../utils/svgUtils";
import "./styles.scss";

const HowItWorksCards = ({ data, onClickLink }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const { pathname } = location;
  const routeName = pathname.split("/")[1];

  return (
    <div className="how-it-works-cards-container">
      {data.map((item, index) => {
        const linkIcon = getSvgComponent(item.linkIcon);
        return (
          <div key={index} className="how-it-works-card">
            <div className="inner-card">
              <img src={getSvgComponent(item.icon)} className="card-icon" />
              <div>
                <p className="card-heading">
                  {routeName
                    ? t(`${routeName}.${item.heading}`)
                    : t(`app.${item.heading}`)}
                </p>
                <p className="card-description">
                  {routeName
                    ? t(`${routeName}.${item.description}`)
                    : t(`app.${item.description}`)}
                </p>
                {item.linkText ? (
                  <div
                    className="card-link-container"
                    onClick={() => onClickLink(item.action)}
                  >
                    <p className="card-link">{t(item.linkText)}</p>
                    {item.linkIcon ? (
                      <img src={linkIcon} className="card-link-icon" />
                    ) : null}
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default HowItWorksCards;
